import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        path: "/",
        name: "game",
        component: () => import("../views/Game"),
    },
    {
        path: "/my",
        name: "my",
        component: () => import("../views/user/My"),

    },
    //帮助
    {
        path: "/helper", name: "helperLink", component: () => import("../views/myHelper/Helper"),
    },
    {
        path: "/myHelper/questions/questions", name: "questionsLink", component: () => import("../views/myHelper/questions/Questions"),
    },
    {
        path: "/myHelper/feedback/feedback", name: 'feedbackLink', component: () => import("../views/myHelper/feedback/Feedback")

    },
    {
        path: "/myHelper/chat/robot", name: 'robotLink', component: () => import("@/views/myHelper/chat/Robot")
    },
    {
        path: "/myHelper/feedback/myservice", name: 'feedbackMyServiceLink', component: () => import("@/views/myHelper/feedback/MyService")

    },
    {  //合服
        path: "/myHelper/questions/detail", name: 'questionsDetailLink', component: () => import("@/views/myHelper/questions/Detail")
    },
    {
        path: "/myHelper/feedback/detail/:id", name: 'feedbackDetailLink', component: () => import("@/views/myHelper/feedback/Detail")
    },

    {
        path: "/user/bindemail",
        name: "bindEmail",
        component: () => import("../views/user/BindEmail"),
    },
    {
        path: "/gameplay/",
        name: "gameplay",
        component: () => import("@/views/GamePlay"),
    },
    {
        path: "/user/password",
        name: "password",
        component: () => import("../views/user/Password"),
    },
    {
        path: "/user/bindmobile",
        name: "bindMobile",
        component: () => import("../views/user/BindMobile"),
    },
    {
        path: "/user/AccountDestroy",
        name: "accountdestroyLink",
        component: () => import("../views/user/AccountDestroy"),
    },
    {
        path: "/user/myinfo", name: 'myInfoLink', component: () => import("@/views/user/MyInfo")
    },
    // 游戏点数
    {
        path: "/gamePoints/points", name: 'points', component: () => import("@/views/gamePoints/Points")
    },
    {
        path: "/gamePoints/paypassword", name: 'payPassword', component: () => import("@/views/gamePoints/PayPassword")
    },
    {
        path: "/gamePoints/payforgot", name: 'payForgot', component: () => import("@/views/gamePoints/PayForgot")
    },
    {
        path: "/gamePoints/install", name: 'install', component: () => import("@/views/gamePoints/install")
    },


    //落地页
    {
        path: '/store/apps/details', name: 'playLink', component: () => import("@/views/ldy/squeezePlay")
    },
    //落地页
    /* {
         path: '/ldy/squeezePlay', name:'squeezePlayLink', component: () => import("@/views/ldy/squeezePlay") 
     }
     ,*/

    //暂无开放功能
    {
        path: '/mini/OnlineMinigames', name: 'OnlineMinigames', component: () => import("@/views/mini/OnlineMinigames")
    },  //暂无开放功能
    {
        path: '/mini/GameIntroduction',
        name: 'GameIntroduction',
        component: () => import("../views/mini/GameIntroduction")
    },
    {
        path: '/zwsjdj', name: 'zwsjdj', component: () => import("@/views/Zwsj")
    },  //暂无开放功能
    {
        path: '/zwsjbx', name: 'zwsjbx', component: () => import("@/views/Zwsj")
    },  //暂无开放功能
    {
        path: '/zwsjdjyx', name: 'zwsjdjyx', component: () => import("@/views/Zwsj")
    },
    //404 页面
    {
        path: '/404', name: '404', component: () => import("@/views/404")
    },
    //单机游戏
    {
        path: '/singleGame/ConsoleGame',
        name: 'c',
        component: () => import("../views/singleGame/ConsoleGame")
    },
    //短剧栏目
    {
        path: '/shortDrama/playlet',
        name: 'playletLink',
        component: () => import("../views/shortDrama/playlet")
    },
    {
        path: '/shortDrama/videoDisplay',
        name: 'videoDisplay',
        component: () => import("../views/shortDrama/videoDisplay")
    },
    //资讯
    {
        path: '/news/windzxsh',
        name: 'windzxsh',
        component: () => import("@/views/news/windzxsh")
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});
/**
 * 全局前置路由守卫，每一次路由跳转前都进入这个 beforeEach 函数
 */
router.beforeEach((to, from, next) => {
    window.backfullPath = from.fullPath;
    next();
});
export default router;
